import * as Types from '../../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type GetProductionLotsQueryVariables = Types.Exact<{
  salesItemId?: Types.InputMaybe<Types.Scalars['String']['input']>;
  includeDrafts?: Types.Scalars['Boolean']['input'];
  where?: Types.InputMaybe<Types.ProductionLotDocumentFilterInput>;
  order?: Types.InputMaybe<Array<Types.ProductionLotDocumentSortInput> | Types.ProductionLotDocumentSortInput>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  last?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  before?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetProductionLotsQuery = { __typename?: 'Query', productionLots?: { __typename?: 'ProductionLotsConnection', totalCount: number, nodes?: Array<{ __typename?: 'ProductionLotDocument', id: string, tenantId: string, productionLotId: string, productionPlanId: string, productionPlanName: string, customerId?: string | null, customerName?: string | null, poNumber?: string | null, quantity: number, status: Types.ProductionLotStatus, lotNumber: number, isAd: boolean, isTrial: boolean, finishJobProductionCatalogId?: string | null, finishJobProductionCategoryId?: string | null, finishJobWeekReadyDate?: Types.TDateISO | null, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetProductionLotEachesQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.ProductionLotDocumentFilterInput>;
  order?: Types.InputMaybe<Array<Types.ProductionLotDocumentSortInput> | Types.ProductionLotDocumentSortInput>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetProductionLotEachesQuery = { __typename?: 'Query', productionLots?: { __typename?: 'ProductionLotsConnection', totalCount: number, nodes?: Array<{ __typename?: 'ProductionLotDocument', productionLotId: string, netAvailableEaches: number, eachesPerUnit?: number | null }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetProductionJobsQueryVariables = Types.Exact<{
  includeDrafts?: Types.Scalars['Boolean']['input'];
  where?: Types.InputMaybe<Types.ProductionJobDocumentFilterInput>;
  order?: Types.InputMaybe<Array<Types.ProductionJobDocumentSortInput> | Types.ProductionJobDocumentSortInput>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  last?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  before?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetProductionJobsQuery = { __typename?: 'Query', productionJobs?: { __typename?: 'ProductionJobsConnection', totalCount: number, nodes?: Array<{ __typename?: 'ProductionJobDocument', id: string, tenantId: string, productionLotId: string, productionPlanId: string, productionPlanName: string, productionJobId: string, parentProductionJobId?: string | null, productionCatalogId: string, productionCategoryId: string, productionRecipeId: string, customerId?: string | null, customerName?: string | null, locationId?: string | null, locationName?: string | null, categoryName: string, genus: string, series: string, color: string, jobNumber: number, jobExecutionStatus: Types.JobExecutionStatus, postingStatus: Types.JobPostingStatus, quantity: number, isQuantityOverridden: boolean, yield: number, yieldOverride?: number | null, isYieldOverridden: boolean, growWeeksOverride?: number | null, isGrowWeeksOverridden: boolean, plantsPerPotOverride?: number | null, isPlantsPerPotOverridden: boolean, plannedHoursOverride?: number | null, plannedHoursSource: Types.PlannedHoursSource, weekReadyDate: Types.TDateISO, weekReadyIsoWeek: number, weekReadyIsoYear: number, weekStartDate: Types.TDateISO, weekStartIsoWeek: number, weekStartIsoYear: number, lotStatus: Types.ProductionLotStatus, notes?: string | null, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string, isRecipeStale: boolean, lastReconciledRecipeVersion: number, actualYield: number, producedQuantity?: number | null, producedLocationId?: string | null, countedAt?: Types.TDateISO | null, unitLabel: string, eaches: number, requestedEaches: number, eachesPerUnit?: number | null, expectedOutputEaches: number, actualYieldEaches: number, yieldVarianceEaches: number, shrinkEvents: Array<{ __typename?: 'ProductionJobShrinkEventDocument', shrinkEventId: string, shrinkType: Types.ShrinkType, quantity: number, date: Types.TDateISO, notes?: string | null, recordedAt: Types.TDateISO, recordedBy: string }>, shrinkEventEaches: Array<{ __typename?: 'ProductionJobShrinkEventEachesData', shrinkEventId: string, eaches: number }> }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetProductionJobDimensionsQueryVariables = Types.Exact<{
  where: Types.ProductionJobDocumentFilterInput;
  first: Types.Scalars['Int']['input'];
}>;


export type GetProductionJobDimensionsQuery = { __typename?: 'Query', productionJobs?: { __typename?: 'ProductionJobsConnection', totalCount: number, nodes?: Array<{ __typename?: 'ProductionJobDocument', productionJobId: string, productionCategoryId: string, locationId?: string | null, customerId?: string | null, spaceDimensionsSource?: Types.DimensionSource | null, sqFtRequired: number, sqFtReason: Types.SqFtReason, spaceDimensions?: { __typename?: 'ProductionJobSpaceDimensionsData', length: number, stagger: boolean, width: number } | null, spaceEventAttachments: Array<{ __typename?: 'ProductionJobEventAttachmentDocument', eventId: string, source: Types.ProductionEventAttachmentSource }>, spaceBookings: Array<{ __typename?: 'JobSpaceBooking', startIsoWeek: number, startIsoYear: number, endIsoWeek: number, endIsoYear: number, source: Types.JobSpaceBookingSource, spaceTypeCode?: string | null, sqFtPerWeek: number, spaceEventId?: string | null }> }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetProductionScheduleJobQueryVariables = Types.Exact<{
  first: Types.Scalars['Int']['input'];
  where: Types.ProductionJobDocumentFilterInput;
}>;


export type GetProductionScheduleJobQuery = { __typename?: 'Query', productionJobs?: { __typename?: 'ProductionJobsConnection', totalCount: number, nodes?: Array<{ __typename?: 'ProductionJobDocument', productionJobId: string, productionLotId: string }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetProductionJobLabelsQueryVariables = Types.Exact<{
  first: Types.Scalars['Int']['input'];
  where: Types.ProductionJobDocumentFilterInput;
}>;


export type GetProductionJobLabelsQuery = { __typename?: 'Query', productionJobs?: { __typename?: 'ProductionJobsConnection', totalCount: number, nodes?: Array<{ __typename?: 'ProductionJobDocument', productionJobId: string, categoryName: string, color: string, genus: string, series: string }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetProductionJobGrowWeeksQueryVariables = Types.Exact<{
  first: Types.Scalars['Int']['input'];
  where: Types.ProductionJobDocumentFilterInput;
}>;


export type GetProductionJobGrowWeeksQuery = { __typename?: 'Query', productionJobs?: { __typename?: 'ProductionJobsConnection', totalCount: number, nodes?: Array<{ __typename?: 'ProductionJobDocument', productionJobId: string, effectiveGrowWeeks?: number | null, growWeeksOverride?: number | null, isGrowWeeksOverridden: boolean }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetProductionScheduleLotJobsQueryVariables = Types.Exact<{
  first: Types.Scalars['Int']['input'];
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  jobsWhere: Types.ProductionJobDocumentFilterInput;
  lotsWhere: Types.ProductionLotDocumentFilterInput;
}>;


export type GetProductionScheduleLotJobsQuery = { __typename?: 'Query', productionLots?: { __typename?: 'ProductionLotsConnection', totalCount: number, nodes?: Array<{ __typename?: 'ProductionLotDocument', productionLotId: string, lotNumber: number, quantity: number }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null, productionJobs?: { __typename?: 'ProductionJobsConnection', totalCount: number, nodes?: Array<{ __typename?: 'ProductionJobDocument', eaches: number, effectivePlantsPerPot?: number | null, jobExecutionStatus: Types.JobExecutionStatus, postingStatus: Types.JobPostingStatus, unitLabel: string, id: string, tenantId: string, productionLotId: string, productionPlanId: string, productionPlanName: string, productionJobId: string, parentProductionJobId?: string | null, productionCatalogId: string, productionCategoryId: string, productionRecipeId: string, customerId?: string | null, customerName?: string | null, locationId?: string | null, locationName?: string | null, categoryName: string, genus: string, series: string, color: string, jobNumber: number, quantity: number, isQuantityOverridden: boolean, yield: number, yieldOverride?: number | null, isYieldOverridden: boolean, growWeeksOverride?: number | null, isGrowWeeksOverridden: boolean, plantsPerPotOverride?: number | null, isPlantsPerPotOverridden: boolean, plannedHoursOverride?: number | null, plannedHoursSource: Types.PlannedHoursSource, weekReadyDate: Types.TDateISO, weekReadyIsoWeek: number, weekReadyIsoYear: number, weekStartDate: Types.TDateISO, weekStartIsoWeek: number, weekStartIsoYear: number, lotStatus: Types.ProductionLotStatus, notes?: string | null, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string, isRecipeStale: boolean, lastReconciledRecipeVersion: number, actualYield: number, producedQuantity?: number | null, producedLocationId?: string | null, countedAt?: Types.TDateISO | null, requestedEaches: number, eachesPerUnit?: number | null, expectedOutputEaches: number, actualYieldEaches: number, yieldVarianceEaches: number, shrinkEvents: Array<{ __typename?: 'ProductionJobShrinkEventDocument', shrinkEventId: string, shrinkType: Types.ShrinkType, quantity: number, date: Types.TDateISO, notes?: string | null, recordedAt: Types.TDateISO, recordedBy: string }>, shrinkEventEaches: Array<{ __typename?: 'ProductionJobShrinkEventEachesData', shrinkEventId: string, eaches: number }> }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetProductionLotQueryVariables = Types.Exact<{
  productionLotId: Types.Scalars['String']['input'];
}>;


export type GetProductionLotQuery = { __typename?: 'Query', productionLot?: { __typename?: 'ProductionLotStateData', tenantId: string, productionLotId: string, productionPlanId: string, productionItemId?: string | null, customerId?: string | null, customerGroupId?: string | null, poNumber?: string | null, quantity: number, status: Types.ProductionLotStatus, isAd: boolean, isTrial: boolean, isPreFinished: boolean, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string, finishJob: { __typename?: 'ProductionJobData', productionJobId: string, productionCatalogId: string, productionCategoryId: string, productionRecipeId: string, locationId?: string | null, quantity: number, yield: number, weekReadyDate: Types.TDateISO, weekStartDate: Types.TDateISO, notes?: string | null, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string, childJobs: Array<{ __typename?: 'ProductionJobData', productionJobId: string, productionCatalogId: string, productionCategoryId: string, productionRecipeId: string, locationId?: string | null, quantity: number, yield: number, weekReadyDate: Types.TDateISO, weekStartDate: Types.TDateISO, notes?: string | null, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string }> } } | null };

export type GetSplitProductionLotQueryVariables = Types.Exact<{
  productionLotId: Types.Scalars['String']['input'];
}>;


export type GetSplitProductionLotQuery = { __typename?: 'Query', productionLot?: { __typename?: 'ProductionLotStateData', productionLotId: string, productionPlanId: string, lotNumber: number, quantity: number, finishJob: { __typename?: 'ProductionJobData', productionJobId: string, jobNumber: number, weekReadyDate: Types.TDateISO } } | null };

export type GetProductionJobPurchaseOrdersQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.ProductionJobDocumentFilterInput>;
  order?: Types.InputMaybe<Array<Types.ProductionJobDocumentSortInput> | Types.ProductionJobDocumentSortInput>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetProductionJobPurchaseOrdersQuery = { __typename?: 'Query', productionJobs?: { __typename?: 'ProductionJobsConnection', totalCount: number, nodes?: Array<{ __typename?: 'ProductionJobDocument', productionJobId: string, purchaseOrdersForJob: Array<{ __typename?: 'PurchaseOrderForJobData', purchaseOrderId: string, purchaseOrderNumber: string, status: Types.VendorPurchaseOrderStatus, openQuantity: number }> }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type PurchaseOrderForJobFragment = { __typename?: 'PurchaseOrderForJobData', purchaseOrderId: string, purchaseOrderNumber: string, status: Types.VendorPurchaseOrderStatus, openQuantity: number };

export type GetProductionPlansQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.ProductionPlanDocumentFilterInput>;
  order?: Types.InputMaybe<Array<Types.ProductionPlanDocumentSortInput> | Types.ProductionPlanDocumentSortInput>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  last?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  before?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetProductionPlansQuery = { __typename?: 'Query', productionPlans?: { __typename?: 'ProductionPlansConnection', totalCount: number, nodes?: Array<{ __typename?: 'ProductionPlanDocument', id: string, tenantId: string, productionPlanId: string, name: string, status: Types.ProductionPlanStatus, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type ProductionLotSummaryFragment = { __typename?: 'ProductionLotDocument', id: string, tenantId: string, productionLotId: string, productionPlanId: string, productionPlanName: string, customerId?: string | null, customerName?: string | null, poNumber?: string | null, quantity: number, status: Types.ProductionLotStatus, lotNumber: number, isAd: boolean, isTrial: boolean, finishJobProductionCatalogId?: string | null, finishJobProductionCategoryId?: string | null, finishJobWeekReadyDate?: Types.TDateISO | null, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string };

export type ProductionLotEachesFragmentFragment = { __typename?: 'ProductionLotDocument', productionLotId: string, netAvailableEaches: number, eachesPerUnit?: number | null };

export type ProductionJobSummaryFragment = { __typename?: 'ProductionJobDocument', id: string, tenantId: string, productionLotId: string, productionPlanId: string, productionPlanName: string, productionJobId: string, parentProductionJobId?: string | null, productionCatalogId: string, productionCategoryId: string, productionRecipeId: string, customerId?: string | null, customerName?: string | null, locationId?: string | null, locationName?: string | null, categoryName: string, genus: string, series: string, color: string, jobNumber: number, jobExecutionStatus: Types.JobExecutionStatus, postingStatus: Types.JobPostingStatus, quantity: number, isQuantityOverridden: boolean, yield: number, yieldOverride?: number | null, isYieldOverridden: boolean, growWeeksOverride?: number | null, isGrowWeeksOverridden: boolean, plantsPerPotOverride?: number | null, isPlantsPerPotOverridden: boolean, plannedHoursOverride?: number | null, plannedHoursSource: Types.PlannedHoursSource, weekReadyDate: Types.TDateISO, weekReadyIsoWeek: number, weekReadyIsoYear: number, weekStartDate: Types.TDateISO, weekStartIsoWeek: number, weekStartIsoYear: number, lotStatus: Types.ProductionLotStatus, notes?: string | null, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string, isRecipeStale: boolean, lastReconciledRecipeVersion: number, actualYield: number, producedQuantity?: number | null, producedLocationId?: string | null, countedAt?: Types.TDateISO | null, unitLabel: string, eaches: number, requestedEaches: number, eachesPerUnit?: number | null, expectedOutputEaches: number, actualYieldEaches: number, yieldVarianceEaches: number, shrinkEvents: Array<{ __typename?: 'ProductionJobShrinkEventDocument', shrinkEventId: string, shrinkType: Types.ShrinkType, quantity: number, date: Types.TDateISO, notes?: string | null, recordedAt: Types.TDateISO, recordedBy: string }>, shrinkEventEaches: Array<{ __typename?: 'ProductionJobShrinkEventEachesData', shrinkEventId: string, eaches: number }> };

export type ProductionLotDetailsFragment = { __typename?: 'ProductionLotStateData', tenantId: string, productionLotId: string, productionPlanId: string, productionItemId?: string | null, customerId?: string | null, customerGroupId?: string | null, poNumber?: string | null, quantity: number, status: Types.ProductionLotStatus, isAd: boolean, isTrial: boolean, isPreFinished: boolean, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string, finishJob: { __typename?: 'ProductionJobData', productionJobId: string, productionCatalogId: string, productionCategoryId: string, productionRecipeId: string, locationId?: string | null, quantity: number, yield: number, weekReadyDate: Types.TDateISO, weekStartDate: Types.TDateISO, notes?: string | null, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string, childJobs: Array<{ __typename?: 'ProductionJobData', productionJobId: string, productionCatalogId: string, productionCategoryId: string, productionRecipeId: string, locationId?: string | null, quantity: number, yield: number, weekReadyDate: Types.TDateISO, weekStartDate: Types.TDateISO, notes?: string | null, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string }> } };

export type ProductionLotCreatedFragmentFragment = { __typename?: 'ProductionLotStateData', productionLotId: string, productionPlanId: string, lotNumber: number, quantity: number, finishJob: { __typename?: 'ProductionJobData', productionJobId: string, jobNumber: number, weekReadyDate: Types.TDateISO } };

export type ProductionJobDetailsFragment = { __typename?: 'ProductionJobData', productionJobId: string, productionCatalogId: string, productionCategoryId: string, productionRecipeId: string, locationId?: string | null, quantity: number, yield: number, weekReadyDate: Types.TDateISO, weekStartDate: Types.TDateISO, notes?: string | null, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string, childJobs: Array<{ __typename?: 'ProductionJobData', productionJobId: string, productionCatalogId: string, productionCategoryId: string, productionRecipeId: string, locationId?: string | null, quantity: number, yield: number, weekReadyDate: Types.TDateISO, weekStartDate: Types.TDateISO, notes?: string | null, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string }> };

export type CalculateRecipeCostScheduleQueryVariables = Types.Exact<{
  productionRecipeId: Types.Scalars['String']['input'];
  productionRecipeVariationId?: Types.InputMaybe<Types.Scalars['String']['input']>;
  siteLocationId: Types.Scalars['String']['input'];
}>;


export type CalculateRecipeCostScheduleQuery = { __typename?: 'Query', calculateRecipeCost?: { __typename?: 'RecipeCostSummaryResult', additionalCost: number, incompleteCostReasons: Array<string>, isComplete: boolean, laborCost: number, laborCostSource: Types.RecipeLaborSource, materialsCost: number, overallStatus: Types.CostCalcStepSeverity, overheadCost: number, totalCost: number, calcSteps: Array<{ __typename?: 'CostCalcStep', code: string, message: string, severity: Types.CostCalcStepSeverity, context: Array<{ __typename?: 'CostCalcStepContextEntry', key: string, value: string }> }> } | null };

export type ProductionPlanSummaryFragment = { __typename?: 'ProductionPlanDocument', id: string, tenantId: string, productionPlanId: string, name: string, status: Types.ProductionPlanStatus, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string };

export type GetProductionLotOverrideHistoryQueryVariables = Types.Exact<{
  productionLotId: Types.Scalars['String']['input'];
  productionJobId?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetProductionLotOverrideHistoryQuery = { __typename?: 'Query', productionLotOverrideHistory: Array<{ __typename?: 'ProductionLotOverrideHistoryRecord', id: string, eventType: string, field: Types.ProductionLotOverrideField, productionJobId?: string | null, previousValue?: string | null, newValue?: string | null, previousDisplay?: string | null, newDisplay?: string | null, summary: string, occurredAt: Types.TDateISO, occurredBy: string }> };

export type ProductionJobNumberFragment = { __typename?: 'ProductionJobData', productionJobId: string, jobNumber: number };

export type ProductionLotJobNumbersFragment = { __typename?: 'ProductionLotStateData', productionLotId: string, finishJob: { __typename?: 'ProductionJobData', productionJobId: string, jobNumber: number, childJobs: Array<{ __typename?: 'ProductionJobData', productionJobId: string, jobNumber: number, childJobs: Array<{ __typename?: 'ProductionJobData', productionJobId: string, jobNumber: number, childJobs: Array<{ __typename?: 'ProductionJobData', productionJobId: string, jobNumber: number }> }> }> } };

export type GetRecipeJobIdsQueryVariables = Types.Exact<{
  where: Types.ProductionJobDocumentFilterInput;
  order?: Types.InputMaybe<Array<Types.ProductionJobDocumentSortInput> | Types.ProductionJobDocumentSortInput>;
  first: Types.Scalars['Int']['input'];
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetRecipeJobIdsQuery = { __typename?: 'Query', productionJobs?: { __typename?: 'ProductionJobsConnection', totalCount: number, nodes?: Array<{ __typename?: 'ProductionJobDocument', productionJobId: string }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type ProductionJobMovePreviewQueryVariables = Types.Exact<{
  input: Types.ProductionJobMovePreviewInput;
}>;


export type ProductionJobMovePreviewQuery = { __typename?: 'Query', productionJobMovePreview: { __typename?: 'ProductionJobMovePreviewPayload', jobs?: Array<{ __typename?: 'ProductionJobMovePreview', productionJobId: string, productionLotId: string, fromLocationId?: string | null, fromSiteLocationId?: string | null, planted: boolean, toLocationId: string, toSiteLocationId: string, recipeOutcome: Types.ProductionJobMoveRecipeOutcome, destinationVariationName?: string | null, weekReadyDate: Types.TDateISO, currentWeekStartDate: Types.TDateISO, newWeekStartDate: Types.TDateISO, currentGrowWeeks: number, newGrowWeeks: number, spaceEventsAdded: Array<string>, spaceEventsRemoved: Array<string>, keptOverrides: Array<string> }> | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type GetPlannedLotStartsPreviewQueryVariables = Types.Exact<{
  siteLocationId: Types.Scalars['String']['input'];
  lots: Array<Types.PlannedLotInput> | Types.PlannedLotInput;
}>;


export type GetPlannedLotStartsPreviewQuery = { __typename?: 'Query', previewPlannedLotStarts: Array<{ __typename?: 'PlannedLotStartPreview', key: string, productionItemId: string, weekStartDate?: Types.TDateISO | null, growWeeks?: number | null, productionRecipeVariationId?: string | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null }> };

export type OpenPlannedMovesQueryVariables = Types.Exact<{
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  where?: Types.InputMaybe<Types.TaskAssignmentDocumentFilterInput>;
}>;


export type OpenPlannedMovesQuery = { __typename?: 'Query', taskAssignments?: { __typename?: 'TaskAssignmentsConnection', totalCount: number, nodes?: Array<{ __typename?: 'TaskAssignmentDocument', taskAssignmentId: string, productionJobId?: string | null, plannedMove?: { __typename?: 'PlannedProductionJobMove', productionJobId: string, fromLocationName?: string | null, toLocationName: string, moveDate: Types.TDateISO } | null }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export const PurchaseOrderForJobFragmentDoc = new TypedDocumentString(`
    fragment PurchaseOrderForJob on PurchaseOrderForJobData {
  purchaseOrderId
  purchaseOrderNumber
  status
  openQuantity
}
    `, {"fragmentName":"PurchaseOrderForJob"});
export const ProductionLotSummaryFragmentDoc = new TypedDocumentString(`
    fragment ProductionLotSummary on ProductionLotDocument {
  id
  tenantId
  productionLotId
  productionPlanId
  productionPlanName
  customerId
  customerName
  poNumber
  quantity
  status
  lotNumber
  isAd
  isTrial
  finishJobProductionCatalogId
  finishJobProductionCategoryId
  finishJobWeekReadyDate
  createdAt
  createdBy
  updatedAt
  updatedBy
}
    `, {"fragmentName":"ProductionLotSummary"});
export const ProductionLotEachesFragmentFragmentDoc = new TypedDocumentString(`
    fragment ProductionLotEachesFragment on ProductionLotDocument {
  productionLotId
  netAvailableEaches
  eachesPerUnit
}
    `, {"fragmentName":"ProductionLotEachesFragment"});
export const ProductionJobSummaryFragmentDoc = new TypedDocumentString(`
    fragment ProductionJobSummary on ProductionJobDocument {
  id
  tenantId
  productionLotId
  productionPlanId
  productionPlanName
  productionJobId
  parentProductionJobId
  productionCatalogId
  productionCategoryId
  productionRecipeId
  customerId
  customerName
  locationId
  locationName
  categoryName
  genus
  series
  color
  jobNumber
  jobExecutionStatus
  postingStatus
  quantity
  isQuantityOverridden
  yield
  yieldOverride
  isYieldOverridden
  growWeeksOverride
  isGrowWeeksOverridden
  plantsPerPotOverride
  isPlantsPerPotOverridden
  plannedHoursOverride
  plannedHoursSource
  weekReadyDate
  weekReadyIsoWeek
  weekReadyIsoYear
  weekStartDate
  weekStartIsoWeek
  weekStartIsoYear
  lotStatus
  notes
  createdAt
  createdBy
  updatedAt
  updatedBy
  isRecipeStale
  lastReconciledRecipeVersion
  actualYield
  producedQuantity
  producedLocationId
  countedAt
  shrinkEvents {
    shrinkEventId
    shrinkType
    quantity
    date
    notes
    recordedAt
    recordedBy
  }
  unitLabel
  eaches
  requestedEaches
  eachesPerUnit
  expectedOutputEaches
  actualYieldEaches
  yieldVarianceEaches
  shrinkEventEaches {
    shrinkEventId
    eaches
  }
}
    `, {"fragmentName":"ProductionJobSummary"});
export const ProductionJobDetailsFragmentDoc = new TypedDocumentString(`
    fragment ProductionJobDetails on ProductionJobData {
  productionJobId
  productionCatalogId
  productionCategoryId
  productionRecipeId
  locationId
  quantity
  yield
  weekReadyDate
  weekStartDate
  notes
  createdAt
  createdBy
  updatedAt
  updatedBy
  childJobs {
    productionJobId
    productionCatalogId
    productionCategoryId
    productionRecipeId
    locationId
    quantity
    yield
    weekReadyDate
    weekStartDate
    notes
    createdAt
    createdBy
    updatedAt
    updatedBy
  }
}
    `, {"fragmentName":"ProductionJobDetails"});
export const ProductionLotDetailsFragmentDoc = new TypedDocumentString(`
    fragment ProductionLotDetails on ProductionLotStateData {
  tenantId
  productionLotId
  productionPlanId
  productionItemId
  customerId
  customerGroupId
  poNumber
  quantity
  status
  isAd
  isTrial
  isPreFinished
  createdAt
  createdBy
  updatedAt
  updatedBy
  finishJob {
    ...ProductionJobDetails
  }
}
    fragment ProductionJobDetails on ProductionJobData {
  productionJobId
  productionCatalogId
  productionCategoryId
  productionRecipeId
  locationId
  quantity
  yield
  weekReadyDate
  weekStartDate
  notes
  createdAt
  createdBy
  updatedAt
  updatedBy
  childJobs {
    productionJobId
    productionCatalogId
    productionCategoryId
    productionRecipeId
    locationId
    quantity
    yield
    weekReadyDate
    weekStartDate
    notes
    createdAt
    createdBy
    updatedAt
    updatedBy
  }
}`, {"fragmentName":"ProductionLotDetails"});
export const ProductionLotCreatedFragmentFragmentDoc = new TypedDocumentString(`
    fragment ProductionLotCreatedFragment on ProductionLotStateData {
  productionLotId
  productionPlanId
  lotNumber
  quantity
  finishJob {
    productionJobId
    jobNumber
    weekReadyDate
  }
}
    `, {"fragmentName":"ProductionLotCreatedFragment"});
export const ProductionPlanSummaryFragmentDoc = new TypedDocumentString(`
    fragment ProductionPlanSummary on ProductionPlanDocument {
  id
  tenantId
  productionPlanId
  name
  status
  createdAt
  createdBy
  updatedAt
  updatedBy
}
    `, {"fragmentName":"ProductionPlanSummary"});
export const ProductionJobNumberFragmentDoc = new TypedDocumentString(`
    fragment ProductionJobNumber on ProductionJobData {
  productionJobId
  jobNumber
}
    `, {"fragmentName":"ProductionJobNumber"});
export const ProductionLotJobNumbersFragmentDoc = new TypedDocumentString(`
    fragment ProductionLotJobNumbers on ProductionLotStateData {
  productionLotId
  finishJob {
    ...ProductionJobNumber
    childJobs {
      ...ProductionJobNumber
      childJobs {
        ...ProductionJobNumber
        childJobs {
          ...ProductionJobNumber
        }
      }
    }
  }
}
    fragment ProductionJobNumber on ProductionJobData {
  productionJobId
  jobNumber
}`, {"fragmentName":"ProductionLotJobNumbers"});
export const GetProductionLotsDocument = new TypedDocumentString(`
    query GetProductionLots($salesItemId: String, $includeDrafts: Boolean! = false, $where: ProductionLotDocumentFilterInput, $order: [ProductionLotDocumentSortInput!], $first: Int, $after: String, $last: Int, $before: String) {
  productionLots(
    salesItemId: $salesItemId
    includeDrafts: $includeDrafts
    where: $where
    order: $order
    first: $first
    last: $last
    before: $before
    after: $after
  ) {
    nodes {
      ...ProductionLotSummary
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment ProductionLotSummary on ProductionLotDocument {
  id
  tenantId
  productionLotId
  productionPlanId
  productionPlanName
  customerId
  customerName
  poNumber
  quantity
  status
  lotNumber
  isAd
  isTrial
  finishJobProductionCatalogId
  finishJobProductionCategoryId
  finishJobWeekReadyDate
  createdAt
  createdBy
  updatedAt
  updatedBy
}
fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
export const GetProductionLotEachesDocument = new TypedDocumentString(`
    query GetProductionLotEaches($where: ProductionLotDocumentFilterInput, $order: [ProductionLotDocumentSortInput!], $first: Int, $after: String) {
  productionLots(where: $where, order: $order, first: $first, after: $after) {
    nodes {
      ...ProductionLotEachesFragment
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment ProductionLotEachesFragment on ProductionLotDocument {
  productionLotId
  netAvailableEaches
  eachesPerUnit
}
fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
export const GetProductionJobsDocument = new TypedDocumentString(`
    query GetProductionJobs($includeDrafts: Boolean! = false, $where: ProductionJobDocumentFilterInput, $order: [ProductionJobDocumentSortInput!], $first: Int, $after: String, $last: Int, $before: String) {
  productionJobs(
    includeDrafts: $includeDrafts
    where: $where
    order: $order
    first: $first
    last: $last
    before: $before
    after: $after
  ) {
    nodes {
      ...ProductionJobSummary
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment ProductionJobSummary on ProductionJobDocument {
  id
  tenantId
  productionLotId
  productionPlanId
  productionPlanName
  productionJobId
  parentProductionJobId
  productionCatalogId
  productionCategoryId
  productionRecipeId
  customerId
  customerName
  locationId
  locationName
  categoryName
  genus
  series
  color
  jobNumber
  jobExecutionStatus
  postingStatus
  quantity
  isQuantityOverridden
  yield
  yieldOverride
  isYieldOverridden
  growWeeksOverride
  isGrowWeeksOverridden
  plantsPerPotOverride
  isPlantsPerPotOverridden
  plannedHoursOverride
  plannedHoursSource
  weekReadyDate
  weekReadyIsoWeek
  weekReadyIsoYear
  weekStartDate
  weekStartIsoWeek
  weekStartIsoYear
  lotStatus
  notes
  createdAt
  createdBy
  updatedAt
  updatedBy
  isRecipeStale
  lastReconciledRecipeVersion
  actualYield
  producedQuantity
  producedLocationId
  countedAt
  shrinkEvents {
    shrinkEventId
    shrinkType
    quantity
    date
    notes
    recordedAt
    recordedBy
  }
  unitLabel
  eaches
  requestedEaches
  eachesPerUnit
  expectedOutputEaches
  actualYieldEaches
  yieldVarianceEaches
  shrinkEventEaches {
    shrinkEventId
    eaches
  }
}
fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
export const GetProductionJobDimensionsDocument = new TypedDocumentString(`
    query GetProductionJobDimensions($where: ProductionJobDocumentFilterInput!, $first: Int!) {
  productionJobs(where: $where, first: $first) {
    nodes {
      productionJobId
      productionCategoryId
      locationId
      customerId
      spaceDimensionsSource
      spaceDimensions {
        length
        stagger
        width
      }
      spaceEventAttachments {
        ...ProductionJobEventAttachment
      }
      sqFtRequired
      sqFtReason
      spaceBookings {
        startIsoWeek
        startIsoYear
        endIsoWeek
        endIsoYear
        source
        spaceTypeCode
        sqFtPerWeek
        spaceEventId
      }
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}
fragment ProductionJobEventAttachment on ProductionJobEventAttachmentDocument {
  eventId
  source
}`);
export const GetProductionScheduleJobDocument = new TypedDocumentString(`
    query GetProductionScheduleJob($first: Int!, $where: ProductionJobDocumentFilterInput!) {
  productionJobs(first: $first, where: $where, includeDrafts: true) {
    nodes {
      productionJobId
      productionLotId
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
export const GetProductionJobLabelsDocument = new TypedDocumentString(`
    query GetProductionJobLabels($first: Int!, $where: ProductionJobDocumentFilterInput!) {
  productionJobs(first: $first, where: $where, includeDrafts: true) {
    nodes {
      productionJobId
      categoryName
      color
      genus
      series
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
export const GetProductionJobGrowWeeksDocument = new TypedDocumentString(`
    query GetProductionJobGrowWeeks($first: Int!, $where: ProductionJobDocumentFilterInput!) {
  productionJobs(first: $first, where: $where, includeDrafts: true) {
    nodes {
      productionJobId
      effectiveGrowWeeks
      growWeeksOverride
      isGrowWeeksOverridden
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
export const GetProductionScheduleLotJobsDocument = new TypedDocumentString(`
    query GetProductionScheduleLotJobs($first: Int!, $after: String, $jobsWhere: ProductionJobDocumentFilterInput!, $lotsWhere: ProductionLotDocumentFilterInput!) {
  productionLots(first: $first, where: $lotsWhere, includeDrafts: true) {
    nodes {
      productionLotId
      lotNumber
      quantity
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
  productionJobs(
    first: $first
    after: $after
    where: $jobsWhere
    includeDrafts: true
  ) {
    nodes {
      ...ProductionJobSummary
      eaches
      effectivePlantsPerPot
      jobExecutionStatus
      postingStatus
      unitLabel
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment ProductionJobSummary on ProductionJobDocument {
  id
  tenantId
  productionLotId
  productionPlanId
  productionPlanName
  productionJobId
  parentProductionJobId
  productionCatalogId
  productionCategoryId
  productionRecipeId
  customerId
  customerName
  locationId
  locationName
  categoryName
  genus
  series
  color
  jobNumber
  jobExecutionStatus
  postingStatus
  quantity
  isQuantityOverridden
  yield
  yieldOverride
  isYieldOverridden
  growWeeksOverride
  isGrowWeeksOverridden
  plantsPerPotOverride
  isPlantsPerPotOverridden
  plannedHoursOverride
  plannedHoursSource
  weekReadyDate
  weekReadyIsoWeek
  weekReadyIsoYear
  weekStartDate
  weekStartIsoWeek
  weekStartIsoYear
  lotStatus
  notes
  createdAt
  createdBy
  updatedAt
  updatedBy
  isRecipeStale
  lastReconciledRecipeVersion
  actualYield
  producedQuantity
  producedLocationId
  countedAt
  shrinkEvents {
    shrinkEventId
    shrinkType
    quantity
    date
    notes
    recordedAt
    recordedBy
  }
  unitLabel
  eaches
  requestedEaches
  eachesPerUnit
  expectedOutputEaches
  actualYieldEaches
  yieldVarianceEaches
  shrinkEventEaches {
    shrinkEventId
    eaches
  }
}
fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
export const GetProductionLotDocument = new TypedDocumentString(`
    query GetProductionLot($productionLotId: String!) {
  productionLot(productionLotId: $productionLotId) {
    ...ProductionLotDetails
  }
}
    fragment ProductionLotDetails on ProductionLotStateData {
  tenantId
  productionLotId
  productionPlanId
  productionItemId
  customerId
  customerGroupId
  poNumber
  quantity
  status
  isAd
  isTrial
  isPreFinished
  createdAt
  createdBy
  updatedAt
  updatedBy
  finishJob {
    ...ProductionJobDetails
  }
}
fragment ProductionJobDetails on ProductionJobData {
  productionJobId
  productionCatalogId
  productionCategoryId
  productionRecipeId
  locationId
  quantity
  yield
  weekReadyDate
  weekStartDate
  notes
  createdAt
  createdBy
  updatedAt
  updatedBy
  childJobs {
    productionJobId
    productionCatalogId
    productionCategoryId
    productionRecipeId
    locationId
    quantity
    yield
    weekReadyDate
    weekStartDate
    notes
    createdAt
    createdBy
    updatedAt
    updatedBy
  }
}`);
export const GetSplitProductionLotDocument = new TypedDocumentString(`
    query GetSplitProductionLot($productionLotId: String!) {
  productionLot(productionLotId: $productionLotId) {
    ...ProductionLotCreatedFragment
  }
}
    fragment ProductionLotCreatedFragment on ProductionLotStateData {
  productionLotId
  productionPlanId
  lotNumber
  quantity
  finishJob {
    productionJobId
    jobNumber
    weekReadyDate
  }
}`);
export const GetProductionJobPurchaseOrdersDocument = new TypedDocumentString(`
    query GetProductionJobPurchaseOrders($where: ProductionJobDocumentFilterInput, $order: [ProductionJobDocumentSortInput!], $first: Int, $after: String) {
  productionJobs(where: $where, order: $order, first: $first, after: $after) {
    nodes {
      productionJobId
      purchaseOrdersForJob {
        ...PurchaseOrderForJob
      }
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment PurchaseOrderForJob on PurchaseOrderForJobData {
  purchaseOrderId
  purchaseOrderNumber
  status
  openQuantity
}
fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
export const GetProductionPlansDocument = new TypedDocumentString(`
    query GetProductionPlans($where: ProductionPlanDocumentFilterInput, $order: [ProductionPlanDocumentSortInput!], $first: Int, $after: String, $last: Int, $before: String) {
  productionPlans(
    where: $where
    order: $order
    first: $first
    last: $last
    before: $before
    after: $after
  ) {
    nodes {
      ...ProductionPlanSummary
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment ProductionPlanSummary on ProductionPlanDocument {
  id
  tenantId
  productionPlanId
  name
  status
  createdAt
  createdBy
  updatedAt
  updatedBy
}
fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
export const CalculateRecipeCostScheduleDocument = new TypedDocumentString(`
    query CalculateRecipeCostSchedule($productionRecipeId: String!, $productionRecipeVariationId: String, $siteLocationId: String!) {
  calculateRecipeCost(
    productionRecipeId: $productionRecipeId
    productionRecipeVariationId: $productionRecipeVariationId
    siteLocationId: $siteLocationId
  ) {
    additionalCost
    calcSteps {
      code
      context {
        key
        value
      }
      message
      severity
    }
    incompleteCostReasons
    isComplete
    laborCost
    laborCostSource
    materialsCost
    overallStatus
    overheadCost
    totalCost
  }
}
    `);
export const GetProductionLotOverrideHistoryDocument = new TypedDocumentString(`
    query GetProductionLotOverrideHistory($productionLotId: String!, $productionJobId: String) {
  productionLotOverrideHistory(
    productionLotId: $productionLotId
    productionJobId: $productionJobId
  ) {
    id
    eventType
    field
    productionJobId
    previousValue
    newValue
    previousDisplay
    newDisplay
    summary
    occurredAt
    occurredBy
  }
}
    `);
export const GetRecipeJobIdsDocument = new TypedDocumentString(`
    query GetRecipeJobIds($where: ProductionJobDocumentFilterInput!, $order: [ProductionJobDocumentSortInput!], $first: Int!, $after: String) {
  productionJobs(where: $where, order: $order, first: $first, after: $after) {
    nodes {
      productionJobId
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
export const ProductionJobMovePreviewDocument = new TypedDocumentString(`
    query ProductionJobMovePreview($input: ProductionJobMovePreviewInput!) {
  productionJobMovePreview(input: $input) {
    jobs {
      productionJobId
      productionLotId
      fromLocationId
      fromSiteLocationId
      planted
      toLocationId
      toSiteLocationId
      recipeOutcome
      destinationVariationName
      weekReadyDate
      currentWeekStartDate
      newWeekStartDate
      currentGrowWeeks
      newGrowWeeks
      spaceEventsAdded
      spaceEventsRemoved
      keptOverrides
    }
    errors {
      code
      message
    }
  }
}
    `);
export const GetPlannedLotStartsPreviewDocument = new TypedDocumentString(`
    query GetPlannedLotStartsPreview($siteLocationId: String!, $lots: [PlannedLotInput!]!) {
  previewPlannedLotStarts(siteLocationId: $siteLocationId, lots: $lots) {
    key
    productionItemId
    weekStartDate
    growWeeks
    productionRecipeVariationId
    errors {
      code
      message
    }
  }
}
    `);
export const OpenPlannedMovesDocument = new TypedDocumentString(`
    query OpenPlannedMoves($first: Int, $where: TaskAssignmentDocumentFilterInput) {
  taskAssignments(first: $first, where: $where) {
    nodes {
      taskAssignmentId
      productionJobId
      plannedMove {
        productionJobId
        ...TaskPlannedMove
      }
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}
fragment TaskPlannedMove on PlannedProductionJobMove {
  fromLocationName
  toLocationName
  moveDate
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    GetProductionLots: build.query<GetProductionLotsQuery, GetProductionLotsQueryVariables | void>({
      query: (variables) => ({ document: GetProductionLotsDocument, variables })
    }),
    GetProductionLotEaches: build.query<GetProductionLotEachesQuery, GetProductionLotEachesQueryVariables | void>({
      query: (variables) => ({ document: GetProductionLotEachesDocument, variables })
    }),
    GetProductionJobs: build.query<GetProductionJobsQuery, GetProductionJobsQueryVariables | void>({
      query: (variables) => ({ document: GetProductionJobsDocument, variables })
    }),
    GetProductionJobDimensions: build.query<GetProductionJobDimensionsQuery, GetProductionJobDimensionsQueryVariables>({
      query: (variables) => ({ document: GetProductionJobDimensionsDocument, variables })
    }),
    GetProductionScheduleJob: build.query<GetProductionScheduleJobQuery, GetProductionScheduleJobQueryVariables>({
      query: (variables) => ({ document: GetProductionScheduleJobDocument, variables })
    }),
    GetProductionJobLabels: build.query<GetProductionJobLabelsQuery, GetProductionJobLabelsQueryVariables>({
      query: (variables) => ({ document: GetProductionJobLabelsDocument, variables })
    }),
    GetProductionJobGrowWeeks: build.query<GetProductionJobGrowWeeksQuery, GetProductionJobGrowWeeksQueryVariables>({
      query: (variables) => ({ document: GetProductionJobGrowWeeksDocument, variables })
    }),
    GetProductionScheduleLotJobs: build.query<GetProductionScheduleLotJobsQuery, GetProductionScheduleLotJobsQueryVariables>({
      query: (variables) => ({ document: GetProductionScheduleLotJobsDocument, variables })
    }),
    GetProductionLot: build.query<GetProductionLotQuery, GetProductionLotQueryVariables>({
      query: (variables) => ({ document: GetProductionLotDocument, variables })
    }),
    GetSplitProductionLot: build.query<GetSplitProductionLotQuery, GetSplitProductionLotQueryVariables>({
      query: (variables) => ({ document: GetSplitProductionLotDocument, variables })
    }),
    GetProductionJobPurchaseOrders: build.query<GetProductionJobPurchaseOrdersQuery, GetProductionJobPurchaseOrdersQueryVariables | void>({
      query: (variables) => ({ document: GetProductionJobPurchaseOrdersDocument, variables })
    }),
    GetProductionPlans: build.query<GetProductionPlansQuery, GetProductionPlansQueryVariables | void>({
      query: (variables) => ({ document: GetProductionPlansDocument, variables })
    }),
    CalculateRecipeCostSchedule: build.query<CalculateRecipeCostScheduleQuery, CalculateRecipeCostScheduleQueryVariables>({
      query: (variables) => ({ document: CalculateRecipeCostScheduleDocument, variables })
    }),
    GetProductionLotOverrideHistory: build.query<GetProductionLotOverrideHistoryQuery, GetProductionLotOverrideHistoryQueryVariables>({
      query: (variables) => ({ document: GetProductionLotOverrideHistoryDocument, variables })
    }),
    GetRecipeJobIds: build.query<GetRecipeJobIdsQuery, GetRecipeJobIdsQueryVariables>({
      query: (variables) => ({ document: GetRecipeJobIdsDocument, variables })
    }),
    ProductionJobMovePreview: build.query<ProductionJobMovePreviewQuery, ProductionJobMovePreviewQueryVariables>({
      query: (variables) => ({ document: ProductionJobMovePreviewDocument, variables })
    }),
    GetPlannedLotStartsPreview: build.query<GetPlannedLotStartsPreviewQuery, GetPlannedLotStartsPreviewQueryVariables>({
      query: (variables) => ({ document: GetPlannedLotStartsPreviewDocument, variables })
    }),
    OpenPlannedMoves: build.query<OpenPlannedMovesQuery, OpenPlannedMovesQueryVariables | void>({
      query: (variables) => ({ document: OpenPlannedMovesDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useGetProductionLotsQuery, useLazyGetProductionLotsQuery, useGetProductionLotEachesQuery, useLazyGetProductionLotEachesQuery, useGetProductionJobsQuery, useLazyGetProductionJobsQuery, useGetProductionJobDimensionsQuery, useLazyGetProductionJobDimensionsQuery, useGetProductionScheduleJobQuery, useLazyGetProductionScheduleJobQuery, useGetProductionJobLabelsQuery, useLazyGetProductionJobLabelsQuery, useGetProductionJobGrowWeeksQuery, useLazyGetProductionJobGrowWeeksQuery, useGetProductionScheduleLotJobsQuery, useLazyGetProductionScheduleLotJobsQuery, useGetProductionLotQuery, useLazyGetProductionLotQuery, useGetSplitProductionLotQuery, useLazyGetSplitProductionLotQuery, useGetProductionJobPurchaseOrdersQuery, useLazyGetProductionJobPurchaseOrdersQuery, useGetProductionPlansQuery, useLazyGetProductionPlansQuery, useCalculateRecipeCostScheduleQuery, useLazyCalculateRecipeCostScheduleQuery, useGetProductionLotOverrideHistoryQuery, useLazyGetProductionLotOverrideHistoryQuery, useGetRecipeJobIdsQuery, useLazyGetRecipeJobIdsQuery, useProductionJobMovePreviewQuery, useLazyProductionJobMovePreviewQuery, useGetPlannedLotStartsPreviewQuery, useLazyGetPlannedLotStartsPreviewQuery, useOpenPlannedMovesQuery, useLazyOpenPlannedMovesQuery } = injectedRtkApi;
